import { useState } from 'react';
import IconTooltipButton from '../../../../../button/IconTooltipButton';
import DialogActionHiddeLevels from './Dialog';

const HideLevels = () => {
  const [modal, setModal] = useState(false);

  return (
    <>
      <IconTooltipButton
        title={'Hide Levels'}
        icon={'cog'}
        classNameIcon='text-lg'
        style={{
          borderRadius: '0.5rem',
          padding: '0.45rem',
          color: 'var(--primary-foreground)',
          backgroundColor: 'var(--primary)',
          width: 25,
          height: 25
        }}
        onClick={() => setModal(true)}
        className='shadow-sm'
      />
      {modal && <DialogActionHiddeLevels show={modal} onClose={() => setModal(false)} />}
    </>
  );
};

export default HideLevels;
